var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0.8H2C1.33726 0.8 0.8 1.33726 0.8 2V30C0.8 30.6627 1.33726 31.2 2 31.2H30C30.6627 31.2 31.2 30.6627 31.2 30V2C31.2 1.33726 30.6627 0.8 30 0.8ZM2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H30C31.1046 32 32 31.1046 32 30V2C32 0.895431 31.1046 0 30 0H2Z",
    fill: "#524986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2459 27.3131L15.2459 5.44238L16.0459 5.44238L16.0459 27.3131L15.2459 27.3131Z",
    fill: "#524986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9515 16.3779L3.05811 16.3779L3.05811 15.5779L28.9515 15.5779L28.9515 16.3779Z",
    fill: "#524986"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6761 9.11014H8.21179V11.6912H7.06015V9.11014H4.5835V8.01105H7.06015V5.44238H8.21179V8.01105H10.6761V9.11014Z",
    fill: "#524986"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02487 24.7776L6.96729 22.858L5.00159 20.7656L5.90936 19.8685L7.87506 21.9608L9.82724 20.0316L10.6643 20.9226L8.71213 22.8518L10.6684 24.9342L9.76066 25.8313L7.80436 23.749L5.86194 25.6686L5.02487 24.7776Z",
    fill: "#524986"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.486 11.6912H21.3379L24.7592 5.44238H25.9073L22.486 11.6912Z",
    fill: "#524986"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9095 22.0028H19.8169V21.0645H25.9095V22.0028ZM25.9095 24.1888H19.8169V23.2505H25.9095V24.1888Z",
    fill: "#524986"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculating);
export default __webpack_public_path__ + "static/media/calculating.672f9a9e.svg";
export { ForwardRef as ReactComponent };